import { Injectable } from '@angular/core';
import { ProductModel } from '../model/selfcareproducts';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService 
{
  defaultProduct!:ProductModel;
  private productSource = new BehaviorSubject( this.defaultProduct);
  currenProduct = this.productSource.asObservable();

 changeProduct(product: ProductModel) {
    this.productSource.next(product)
  }

  

  constructor() { }


  

  SelectedVal!:string;
  private SelectedSource = new BehaviorSubject( this.SelectedVal);

  currentAccountType=this.SelectedSource.asObservable();
changeAccountTypeSelection(selectec :string)
{
  
this.SelectedSource.next(selectec);
}





}
